import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { TypePessoa } from "@/Models/Pessoa/Pessoa";
import PessoaBloqueio from "@/Models/Pessoa/PessoaBloqueio";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Form, FormProps, Input, notification, Typography } from "antd";
import { usePessoaBloquear, usePessoaBloqueioAtual } from "@/Services/Pessoa/PessoaBloqueioService";
import { useEffect, useRef } from "react";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import PessoaBloqueioTable from "./PessoaBloqueioTable";

const { TextArea } = Input;
const { Text } = Typography;

export interface IPessoaBloqueioDesbloquearModalProps extends Omit<IModalBaseProps, "children"> {
    formProps ?: Omit<FormProps<PessoaBloqueio>, "children">;
    pessoa : TypePessoa;
    onSuccess ?: Parameters<typeof usePessoaBloquear>[0]["onSuccess"];
}

export default function PessoaBloqueioModal ({ 
    formProps,
    pessoa,
    onSuccess,
    ...props
}:IPessoaBloqueioDesbloquearModalProps) {
    const refModal = useRef<ModalBaseRefType|null>(null);

    return <ModalBase
        title="Bloqueios"
        textButtonOpen="Desbloquear"
        propsButtonOpen={{
            icon : <CheckCircleOutlined />
        }}
        width={"65vw"}
        ref={refModal}
        destroyOnClose={true}
        okButtonProps={{
            style : { display : "none" }
        }}
        cancelButtonProps={{ danger : false }}
        cancelText="Fechar"
        {...props}
    >
        <PessoaBloqueioTable
            habilitarFiltros={false}
            filtros={{
                bloqueado : true,
                ativo : true,
                pessoaBloqueio : {
                    codPessoa : pessoa.codigo ?? 0
                } as PessoaBloqueio
            }}
        />
    </ModalBase>;
}

